module.exports = __webpack_public_path__ + "img/no_accessories.3c16e1b4.svg";